<template>  
  <div>
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title>Node Assignment</v-toolbar-title>
        <v-spacer />              
      </v-toolbar>      
      <v-divider/>
      <v-card-text>    
        <v-layout row>
          <v-flex xs12 md6>
            <v-layout row>
              <v-flex xs8>
                <v-text-field dense flat
                  v-model="available.term"
                  append-icon="search"
                  label="Search Available"
                  single-line
                  hide-details
                  @input="search"
                ></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-btn color="green" dark @click="assign" small block>
                assign <v-icon small right>arrow_forward</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>        
            <v-data-table dense class="ramping mt-3"
              :headers="available.headers"
              :items="available.items"
              :search="available.term"
              :loading="nodeLoading"
              loading-text="Loading... Please wait"
              show-select
              v-model="available.selected"            
              item-key="id"
              :items-per-page="15"   
              :mobile-breakpoint="0"         
            > 
              <template v-slot:item.data-table-select="{ isSelected, select }">
                <v-simple-checkbox color="green" :value="isSelected" @input="select($event)"></v-simple-checkbox>
              </template> 
              <template v-slot:item.level="{ item }">
                {{levels[item.level]}}
              </template>            
              <template v-slot:item.name="{ item }">
                {{item.name}}<br/>
                <small>{{item.parent_name}}</small>
              </template>            
            </v-data-table>
          </v-flex>      
          <v-flex xs12 md6>
            <v-layout row>
              <v-flex xs4>
                <v-btn color="orange" dark @click="revoke" small block>
                  <v-icon left small>arrow_back</v-icon> revoke 
                </v-btn>
              </v-flex>
              <v-flex xs8>
                <v-text-field dense flat
                  v-model="assigned.term"
                  append-icon="search"
                  label="Search Assigned"
                  single-line
                  hide-details
                ></v-text-field>
              </v-flex>
            </v-layout>          
            <v-data-table dense class="ramping mt-3"
              :headers="assigned.headers"
              :items="assigned.items"
              :search="assigned.term"
              :loading="assigned.loading"
              loading-text="Loading... Please wait"
              show-select
              v-model="assigned.selected"            
              item-key="id"
              :items-per-page="15"
              :mobile-breakpoint="0"
            > 
              <template v-slot:item.data-table-select="{ isSelected, select }">
                <v-simple-checkbox color="green" :value="isSelected" @input="select($event)"></v-simple-checkbox>
              </template>                         
              <template v-slot:item.level="{ item }">
                {{levels[item.level]}}
              </template> 
              <template v-slot:item.name="{ item }">
                {{item.name}}<br/>
                <small>{{item.parent_name}}</small>
              </template>     
            </v-data-table>
          </v-flex>      
        </v-layout>    
      </v-card-text>
    </v-card>  
  </div>  
</template>

<script>
import { Ripple } from 'vuetify/lib/directives'
import { debounce } from 'lodash'
import Model from '@/app/models/Admin'
const  model = new Model()


export default {  
  directives : {Ripple},
  data : () => ({    
    perPage:'10',
    perPageOptions: ['10', '20', '50', '-1'],    
    available : {      
      items : [], checkedAll:false, selected : [],
      loading : false, term : null,
      headers : [{ text: 'Node', value: 'name' },{text: 'Level', value:'level'}],
    },
    assigned : {
      items : [], checkedAll:false, selected : [],
      loading : false, term : null,
      headers : [{ text: 'Node', value: 'name' },{text: 'Level', value:'level'}],
    },
    term : null,
    items: [],     
    page : 0,      
    totalPages: 0,      
    loading: false, nodeLoading: false,
    status: {1:'active',0:'inactive'},        
  }),  
  computed: {  
    levels(){
      return this.$store.getters.DICTIONS.RegionLevel;      
    },  
    filterAvailable(){
      if (!this.available.term || this.available.term.length < 1) {       
        return this.isChecked(this.available.items, this.available.checkedAll)
      }
      return this.isChecked(this.available.items.filter(item => {
        const textOne    = item.name.toLowerCase()
        const searchText = this.available.term.toLowerCase()
        return textOne.indexOf(searchText) > -1; 
      }), this.available.checkedAll)      
    },
    filterAssigned(){
      if (!this.assigned.term || this.assigned.term.length < 1) {
        return this.isChecked(this.assigned.items, this.assigned.checkedAll)
      }
      return this.isChecked(this.assigned.items.filter(item => {
        const textOne    = item.name.toLowerCase()
        const searchText = this.assigned.term.toLowerCase()
        //return item.name.toLowerCase().startsWith(this.available.term.toLowerCase())
        return textOne.indexOf(searchText) > -1; 
      }), this.assigned.checkedAll)           
    },
  },
  watch: {
    '$route.query.id'() {
        this.init();
    }
  },
  mounted () {
    this.init();
    model.nodes().then(res=>{
      //console.log(res.data);
      if(Array.isArray(res.data)){
        res.data.forEach(item=>{
          console.log(item);
          this.available.items.push(item); 
        })
      }
    })
  },
  methods: {    
    search: debounce(function (e) {      
      this.readNodes(e)
    }, 400),

    readNodes(term){
      this.nodeLoading = true;
      this.available.items = [];
      model.nodes({q:term}).then(res=>{
        if(Array.isArray(res.data)){
          res.data.forEach(item=>{
            console.log(item);
            this.available.items.push(item); 
          })
        }
        this.nodeLoading = false;
      })
    },

    searchAvailable: debounce(function (term) {
      this.available.term = term;                  
    }, 800),

    searchAssigned : debounce(function (term) {
      this.assigned.term = term;            
    }, 800),

    isChecked(result, status){
      result.forEach(item=>{item.checked = status ? true:false});
      return result;
    },

    init () {
      this.available.loading = true; this.assigned.loading = true;             
      model.nodeAssignment({id:this.$route.query.id}).then(response => {                                        
        this.readItems(response)
        this.available.loading = false
        this.assigned.loading  = false
      })
    },

    readItems (response){
      if(response.items){      
        this.assigned.items = [];   
        if(Array.isArray(response.items.available)){
          response.items.available.forEach(item=>{                    
            this.available.items.push(item);            
          });          
        } 
        if(Array.isArray(response.items.assigned)){
          response.items.assigned.forEach(item=>{
            this.assigned.items.push(item);            
          });          
        }        
      }            
    },
   
    selectAvailable (data) {
      const idx = this.available.items.findIndex(u => u.name === data.name)
      this.available.items[idx].checked = !this.available.items[idx].checked           
    },

    selectAssigned (data) {
      const idx = this.assigned.items.findIndex(u => u.name === data.name)
      this.assigned.items[idx].checked = !this.assigned.items[idx].checked
    },

    assign(){
      let arr = []; this.available.selected.forEach(item=>{arr.push(item.id)})
      this.available.loading = true;
      model.nodeAssign({nodes:arr,user_id:this.$route.query.id}).then(res=>{
        this.available.loading = false; this.readItems(res)
      })
    },

    revoke(){
      let arr = []; this.assigned.selected.forEach(item=>{arr.push(item.id)})
      this.assigned.loading = true;
      model.nodeRevoke({nodes:arr, user_id:this.$route.query.id}).then(res=>{
        this.assigned.loading = false; this.readItems(res)
      })
    },

    getStatusColor (status) {
      if (status === 1) {
        return 'success'
      }

      if (status === 'processing') {
        return 'info'
      }

      return 'danger'
    },
  },  
}
</script>
<style>
.ramping td, .ramping th {
    padding: 0 5px;
}
</style>